{% block sw_cms_element_acris_faq_config_single %}
    <div class="sw-cms-el-config-acris-faq-single">
        <sw-entity-multi-id-select
            :repository="faq"
            labelProperty="name"
            :label="$tc('acris-faq.elements.faqSingle.config.label.selectGroups')"
            :helpText="$tc('acris-faq.elements.faqSingle.config.label.helpText')"
            v-model:value="element.config.faqs.value">
        </sw-entity-multi-id-select>
    </div>
{% endblock %}


